import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, Subject, Subscription } from 'rxjs';
import { CustomerData } from 'src/app/models/customer.model';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { KnBrOrderHistoryService } from '../store/kn-br-order-history/kn-br-order-history.service';
import { KnBrOrderHistory } from '../models/kn-br-order.model';
import { KN_BR_CUSTOMER_CURRENT } from 'src/constants/api.endpoints.constant';
import { Occ, OccEndpointsService } from '@spartacus/core';
import { HttpClient } from '@angular/common/http';
import { Order } from '@spartacus/order/root';

@Component({
  selector: 'knbr-kn-br-order-confirmation-ledger',
  templateUrl: './kn-br-order-confirmation-ledger.component.html',
  styleUrls: ['./kn-br-order-confirmation-ledger.component.scss'],
  standalone: false,
})
export class KnBrOrderConfirmationLedgerComponent implements OnInit, OnDestroy {
  customerNumber: string;
  private destroy$ = new Subject<void>();

  customerContextData$: Observable<CustomerData> = this.knBrCustomerContextService.get$;
  orderConfirmationLedgerForm!: FormGroup;
  PAGE_SIZE = 50;
  orderHistoryResult$: Observable<KnBrOrderHistory[]> = this.knBrOrderHistoryService.list$;
  isLoader$: Observable<boolean> = this.knBrOrderHistoryService.loader$;
  selectedOrderDetails?: Order;
  allSubscriptions = new Subscription();
  constructor(
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected knBrCommonService: KnBrCommonService,
    protected knBrOrderHistoryService: KnBrOrderHistoryService,
    protected fb: FormBuilder,
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.allSubscriptions.add(this.knBrCustomerContextService.get$.subscribe(data => {
    const selectedCustomer = data;
    this.customerNumber = selectedCustomer?.customerNumber ? selectedCustomer.customerNumber : null;
      this.loadOrderHistoryOnPageInitialLoad();
    }));
    this.allSubscriptions.add(this.orderHistoryResult$.subscribe(orderHistoryResult => {
      if (orderHistoryResult?.length > 0) {
        const firstOrderCode = orderHistoryResult[0]?.code;
        if (firstOrderCode && this.selectedOrderDetails?.code !== firstOrderCode) {
          this.loadSpecificOrderDetails(firstOrderCode, false);
        }
      } else {
        this.selectedOrderDetails = undefined;
      }
    }));
    this.allSubscriptions.add(this.knBrOrderHistoryService.loader$.subscribe({
      next: response => {
        this.knBrCommonService.setSpinner(response)
      },
      error: error => { }
    }))
  }

  initForm() {
    this.orderConfirmationLedgerForm = this.fb.group({
      salesOrderNumber: [''],
      purchaseOrderNumber: [''],
    });
  }
  submitForm() {
    if (this.orderConfirmationLedgerForm.valid) {
      const { ...payload } = this.orderConfirmationLedgerForm.getRawValue();
      const updatedPayload = { ...payload };
      updatedPayload.currentPage = 0;

      this.knBrOrderHistoryService.search(updatedPayload);
    }
  }
  private loadOrderHistoryOnPageInitialLoad() {
    const payload:any = {
      accountNumber: this.customerNumber,
      currentPage: 0,
      startDate: '',
      endDate: '',
      pageSize: this.PAGE_SIZE,
    };
    this.knBrOrderHistoryService.search(payload);
  }

  get isSearchDisabled(): boolean {
    const orderNumber =
      this.orderConfirmationLedgerForm.get('salesOrderNumber')?.value || '';

    const poNumber =
      this.orderConfirmationLedgerForm.get('purchaseOrderNumber')?.value || '';

    return !orderNumber.trim() && !poNumber.trim();
  }

  loadSpecificOrderDetails(orderCode: string, allowToggle = true) {
    if(!orderCode) {
      return;
    } else if (allowToggle && orderCode === this.selectedOrderDetails?.code) {
      this.selectedOrderDetails = undefined;
      return;
    }
    this.knBrCommonService.setSpinner(true);
    this.orderDetailsEndPoint(orderCode).subscribe({
      next: (order) => {
        this.selectedOrderDetails = order;
        this.cdr.markForCheck();
        this.knBrCommonService.setSpinner(false);
        console.log('Order details loaded:', order);
      },
      error: (err) => {
        this.knBrCommonService.setSpinner(false);
        console.error('Error loading order details:', err);
      }
    });
  }

  orderDetailsEndPoint(orderCode: string): Observable<Order> {
    const customerNumber = this.customerNumber ? this.customerNumber : KN_BR_CUSTOMER_CURRENT;
    return this.http
      .get(
        this.occEndpoints.buildUrl('orderDetail', { urlParams: { customerId: customerNumber, orderId: orderCode } })
      );
  }

  downloadOrder(orderCode: string) {
    if (!orderCode) {
      return;
    }
    this.knBrCommonService.downloadOrderConfirmationLedger(orderCode, `Order_${orderCode}`)
  }



  getLineItemStatus(lineItem: any): string {
  if (lineItem?.openQuantity === 0 && lineItem?.shippedQuantity > 0) {
    return 'FULLY SHIPPED';
  }

  if (lineItem?.shippedQuantity > 0) {
    return 'PARTIALLY SHIPPED';
  }

  if (lineItem?.openQuantity > 0) {
    return 'NOT SHIPPED';
  }

  return '';
}

  getFullyShippedCount(order: any): number {
    return order?.orderEntries?.filter((lineItem: any) => this.getLineItemStatus(lineItem) === 'FULLY SHIPPED').length || 0;
  }
  getPartiallyShippedCount(order: any): number {
    return order?.orderEntries?.filter((lineItem: any) => this.getLineItemStatus(lineItem) === 'PARTIALLY SHIPPED').length || 0;
  }
  getNotShippedCount(order: any): number {
    return order?.orderEntries?.filter((lineItem: any) => this.getLineItemStatus(lineItem) === 'NOT SHIPPED').length || 0;
  }

  resetForm() {
    this.orderConfirmationLedgerForm.reset();
    this.loadOrderHistoryOnPageInitialLoad();
  }

  ngOnDestroy() {
    this.allSubscriptions?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

}
